const authDataKey = 'mlmcore-vo-auth-data';

function loggedIn() {
	const authData = localStorage.getItem(authDataKey);

	if (authData) {
		const data = JSON.parse(authData);

		return data.token !== null;
	}

	return false;
}

function isActivated() {
	const authData = localStorage.getItem(authDataKey);
	const data = JSON.parse(authData);

	if (data.bin_network_id === "1" || data.bin_network_id === 1) {
		return true
	}

	return false;
}

function setData(data) {
	localStorage.setItem(authDataKey, JSON.stringify(data));
}

function setProfileData(data) {
	let token = getToken()
	data['token'] = token
	setData(data)
}

function setImageData (data) {
	let token = getToken()
	let user = getUserData()

	user.user_image = data

	setData({
		token: token,
		user: user
	})
}

function getUserData() {
	const authData = localStorage.getItem(authDataKey);

	if (authData) {
		const data = JSON.parse(authData);

		return data;
	}

	return null;
}

function getToken() {
	const authData = localStorage.getItem(authDataKey);

	if (authData) {
		const data = JSON.parse(authData);
		return data.token;
	}

	return null;
}

function getRandomNumber() {
	const randomNumber = (min,max) => {
		return (Math.floor(Math.random()*(max-min+1)+min));
	}
	const random = localStorage.getItem('randomNumber');

	if (!random) {
		localStorage.setItem('randomNumber', randomNumber(100, 499))
	}
	return localStorage.getItem('randomNumber')
}

function clearRandomNumber() {
	localStorage.removeItem('randomNumber');
}

function clearData() {
	localStorage.removeItem(authDataKey);
}

export default {
	loggedIn,
	isActivated,
	setData,
	setProfileData,
	setImageData,
	getUserData,
	getToken,
	getRandomNumber,
	clearRandomNumber,
	clearData,
};